module.exports = __webpack_public_path__ + "static/media/suraj.97d7c44e.jpg";